import { render, staticRenderFns } from "./vanType.vue?vue&type=template&id=cf9f21b0"
import script from "./vanType.vue?vue&type=script&lang=js"
export * from "./vanType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports